<div>
  <div *ngIf="!documentList.itemCount" class="bordered">
    <div class="empty-info text-center">
      Nejsou k dispozici žádné dokumenty
    </div>
  </div>

  <div *ngIf="documentList.itemCount" class="mb-30">
    <div class="m-20">
      <span (click)="onCollapseAll(false)" class="pr-10"><a><i class="fa fa-lg fa-angle-double-down"></i></a> Rozbalit vše</span>
      <span (click)="onCollapseAll(true)" class="pr-10"><a><i class="fa fa-lg fa-angle-double-up"></i></a> Sbalit vše</span>
      <span (click)="onDocumentSort('timestamp')">
        <a><i class="fa" [ngClass]="{'fa-sort-amount-asc': documentSortOrder.direction === 'desc', 'fa-sort-amount-desc': documentSortOrder.direction === 'asc'}"></i></a> Seřadit dle data
      </span>
    </div>

    <div class="document-container">
      <table>
        <ng-container *ngFor="let document of documentList.list" >
          <thead [ngClass]="{ collapsed: document.collapsed || !document.components?.length }">
            <tr>
              <td colspan="3">
                <span class="document-flag reference-number"><strong>Číslo jednací:</strong> {{ document.referenceNumber }}</span>

                <ng-container *ngIf="document.folder && folderId !== document.folder.id">
                  <span class="document-flag referenced-folder">Propojený dokument ze spisu {{ document.folder.name }}</span>
                </ng-container>

                <span *ngIf="document.analog" class="document-flag analog-document">Analogový dokument</span>

                <ng-container *ngIf="showDocumentRelations">
                  <span *ngIf="document.constructionObject" class="document-flag referenced-document">Propojený dokument - SO {{ document.constructionObject | constructionObjectName }}</span>
                  <span *ngIf="document.parcel" class="document-flag referenced-document">Propojený dokument - parcela {{ document.parcel | parcelName }}</span>
                  <span *ngIf="document.title" class="document-flag referenced-document">Propojený dokument - LV {{ document.title | titleName }}</span>
                  <span *ngIf="document.subject" class="document-flag referenced-document">Propojený dokument - vlastník {{ document.subject | subjectName }}</span>
                </ng-container>
              </td>
              <td colspan="3">

              </td>
            </tr>
            <tr class="bordered-bottom">
              <td rowspan="3" class="first-col">
                <span *ngIf="document.collapsed" (click)="document.collapsed = !document.collapsed"><a><i class="fa fa-lg fa-angle-double-down"></i></a></span>
                <span *ngIf="!document.collapsed" (click)="document.collapsed = !document.collapsed"><a><i class="fa fa-lg fa-angle-double-up"></i></a></span>
              </td>
              <td>
                <span class="label">PID:</span> {{ document.pid }}
              </td>
              <td>
                <span class="label">Podoba:</span> {{ document.analog ? 'Analogová' : 'Digitální' }}
              </td>
              <td>
                <span class="label">Počet komponent:</span> {{ document.components.length }}
              </td>
              <td>
                <span class="label">Způsob vytvoření:</span> {{ document.sourceType | documentSourceTypeName }}
              </td>
              <td>
                <span class="label">Vytvořeno:</span> {{ document.timestamp | date : 'short' }}
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <span>Název dokumentu: </span><strong>{{ document.name }}</strong>
              </td>
              <td colspan="3">
                <div class="text-right" *ngIf="document.folder && folderId !== document.folder.id">
                   </div>
                <div class="text-right">
                  <ng-container *ngIf="document.folder && folderId !== document.folder.id">
                    <a class="ml-5" title="Zobrazit spis" *ngIf="document.folder.businessCase" uiSref="symap.project.cases.detail" [uiParams]="{ id: document.folder.businessCase.id, tab: 'documents-epd' }"><i class="fa fa-lg fa-hand-o-right"></i></a>
                    <a class="ml-5" title="Zobrazit spis" *ngIf="document.folder.geometricPlanRequest" uiSref="symap.project.geometricPlanRequests.detail" [uiParams]="{ id: document.folder.geometricPlanRequest.id, tab: 'documents-epd' }"><i class="fa fa-lg fa-hand-o-right"></i></a>
                    <a class="ml-5" title="Zobrazit spis" *ngIf="document.folder.opinionRequest" uiSref="symap.project.opinionRequests.detail" [uiParams]="{ id: document.folder.opinionRequest.id, tab: 'documents-epd' }"><i class="fa fa-lg fa-hand-o-right"></i></a>
                    <a class="ml-5" title="Zobrazit spis" *ngIf="!document.folder.businessCase && !document.folder.geometricPlanRequest && !document.folder.opinionRequest" uiSref="symap.project.info" [uiParams]="{ tab: 'documents-epd' }"><i class="fa fa-lg fa-hand-o-right"></i></a>
                  </ng-container>
                  <ng-container *ngIf="showDocumentRelations">
                    <a class="ml-5" title="Přejít na místo propojení dokumentu" *ngIf="document.constructionObject" uiSref="symap.project.constructionObjects.detail" [uiParams]="{ id: document.constructionObject.id, tab: 'documents-epd' }"><i class="fa fa-lg fa-hand-o-right"></i></a>
                    <a class="ml-5" title="Přejít na místo propojení dokumentu" *ngIf="document.parcel" uiSref="symap.project.parcels.detail" [uiParams]="{ id: document.parcel.id, tab: 'documents-epd' }"><i class="fa fa-lg fa-hand-o-right"></i></a>
                    <a class="ml-5" title="Přejít na místo propojení dokumentu" *ngIf="document.title" uiSref="symap.project.titles.detail" [uiParams]="{ id: document.title.id, tab: 'documents-epd' }"><i class="fa fa-lg fa-hand-o-right"></i></a>
                    <a class="ml-5" title="Přejít na místo propojení dokumentu" *ngIf="document.subject" uiSref="symap.project.owners.detail" [uiParams]="{ ownerId: document.subject.id, tab: 'documents-epd' }"><i class="fa fa-lg fa-hand-o-right"></i></a>
                  </ng-container>
                  <ng-container *ngIf="document.folder && folderId === document.folder.id">
                    <ng-container *ngIf="canEdit && canManipulateDocument(document)">
                      <a class="ml-5" title="Zařadit" *ngIf="document.sourceType === 'EPD'" uiSref="symap.project.document-classify.detail" [uiParams]="{ id: document.id }"><i class="fa fa-lg fa-external-link-square"></i></a>
                      <a class="ml-5" title="Vrátit EPD" *ngIf="document.sourceType === 'EPD'" (click)="onReturnDocument(document)"><i class="fa fa-lg fa-recycle"></i></a>
                    </ng-container>
                    <a class="ml-5" (click)="onUpdateDocument(document)" [tooltip]="'Metadata dokumentu / poznámka'"><i class="fa fa-lg fa-info-circle"></i></a>
                  </ng-container>
                  <ng-container *ngIf="canEdit && !document.folder">
                    <a class="ml-5 button" title="Zařadit" *ngIf="document.sourceType === 'EPD'" uiSref="symap.project.document-classify.detail" [uiParams]="{ id: document.id }"><i class="fa fa-lg fa-external-link-square"></i> Zařadit</a>
                    <a class="ml-5 button red" title="Vrátit EPD" *ngIf="document.sourceType === 'EPD'" (click)="onReturnDocument(document)"><i class="fa fa-lg fa-recycle"></i> Vrátit EPD</a>
                  </ng-container>
                </div>
              </td>
            </tr>
          </thead>
          <ng-container *ngIf="!document.collapsed && document.components?.length">
            <tbody class="document-body">
            <tr>
              <td class="first-col"></td>
              <td (click)="onComponentSort('baseName')">
                <span class="label sort-{{ componentSortOrder.direction }}" [ngClass]="{ 'sort-active': componentSortOrder.sortBy === 'baseName' }">Název komponenty (souboru)</span>
              </td>
              <td (click)="onComponentSort('attachmentType')">
                <span class="label sort-{{ componentSortOrder.direction }}" [ngClass]="{ 'sort-active': componentSortOrder.sortBy === 'attachmentType' }">Typ komponenty</span>
              </td>
              <td (click)="onComponentSort('sourceType')">
                <span class="label sort-{{ componentSortOrder.direction }}" [ngClass]="{ 'sort-active': componentSortOrder.sortBy === 'sourceType' }">Způsob vytvoření</span>
              </td>
              <td (click)="onComponentSort('timestamp')">
                <span class="label sort-{{ componentSortOrder.direction }}" [ngClass]="{ 'sort-active': componentSortOrder.sortBy === 'timestamp' }">Vytvořeno</span>
              </td>
              <td (click)="onComponentSort('updatedTimestamp')">
                <span class="label sort-{{ componentSortOrder.direction }}" [ngClass]="{ 'sort-active': componentSortOrder.sortBy === 'updatedTimestamp' }">Změněno</span>
              </td>
              <td></td>
            </tr>
            <tr *ngFor="let component of document.components" class="component-row" [ngClass]="{ 'txt-cancelled': component.cancelled }">
              <td class="first-col">
                <i *ngIf="fileType(component, 'pdf')" class="fa fa-lg fa-blue fa-file-pdf-o"></i>
                <i *ngIf="fileType(component, 'word')" class="fa fa-lg fa-blue fa-file-word-o"></i>
                <i *ngIf="fileType(component, 'excel')" class="fa fa-lg fa-blue fa-file-excel-o"></i>
                <i *ngIf="fileType(component, '')" class="fa fa-lg fa-blue fa-file"></i>
              </td>
              <td>{{ component.baseName }}</td>
              <td>
                <span *ngIf="component.attachmentType">{{ { type: component.attachmentType } | attachmentType : 'title' }}</span>
                <span *ngIf="!component.attachmentType" class="txt-muted"><i class="fa fa-exclamation-triangle color-red"></i> Je potřeba vybrat typ komponenty</span>
              </td>
              <td>{{ component.sourceType | documentSourceTypeName }}</td>
              <td class="small-padding">
                <span class="txt-small">{{ component.timestamp | date : 'short' }}</span><br>
                <span class="txt-small">{{ component.createdUser | username:false :false }}</span>
              </td>
              <td class="small-padding">
                <span class="txt-small">{{ component.updatedTimestamp | date : 'short' }}</span><br>
                <span class="txt-small">{{ component.updatedUser | username:false :false }}</span>
              </td>
              <td>
                <div *ngIf="!component.cancelled" class="text-right">
                  <span class="action-button">
                    <a *ngIf="mapEnabled && fileType(component, 'vfk')" uiSref="symap.project.map" [uiParams]="{ document: component.id, tool: 'gp-vfk' }" title="Náhled VFK v mapě" class="mr-10" target="_blank">
                      <i class="fa fa-map fa-lg"></i>
                    </a>
                  </span>

                  <span class="action-button" *ngIf="component.canViewPDF">
                    <a href="{{ getComponentUrl(component) }}" title="Náhled" target="_blank">
                      <i class="fa fa-lg fa-eye"></i>
                    </a>
                  </span>

                  <span class="action-button">
                    <a (click)="onUpdateComponent(component, document)" [tooltip]="'Metadata komponenty / poznámka'"><i class="fa fa-lg fa-info-circle"></i></a>
                  </span>

                  <span class="action-button" style="padding-left: 7px;">
                    <a href="{{restBaseUrl}}/documents/{{document.id}}/components/{{component.id}}/content?t={{authToken}}" title="Stáhnout">
                      <i class="fa fa-lg fa-download"></i>
                    </a>
                  </span>

                  <ng-container *ngIf="folderId === document.folder?.id">
                    <span *ngIf="canEdit && (component.sourceType === 'MPV_GENERATED' || (component.sourceType === 'MIGRATED' && (component.attachmentType === 'CONTRACT' || component.attachmentType === 'COVERING_LETTER'))) && (fileType(component, 'word') || fileType(component, 'excel'))" class="action-button">
                      <gmt-button [clickAction]="onEditComponent(component)" [gmtDisabled]="!!component.editLock" [tooltip]="component.editUser ? ('Edituje: ' + (component.editUser | username: false:false)) : 'Editace'" [showTitle]="false">
                        <i class="fa fa-lg fa-pencil"></i>
                      </gmt-button>
                    </span>
                    <span *ngIf="canEdit && canManipulateComponent(document, component)" class="action-button">
                      <a (click)="onCancelComponent(component)" title="Zneplatnit"><i class="fa fa-lg fa-trash-o black"></i></a>
                    </span>
                  </ng-container>
                </div>
              </td>
            </tr>
            </tbody>
          </ng-container>
          <tbody class="document-spacing">
            <tr><td><div></div></td></tr>
          </tbody>
        </ng-container>
      </table>
    </div>
  </div>

  <div class="mt-20">
    <fileupload
      *ngIf="canEdit && uploadDestination"
      [(files)]="uploadingFiles"
      [message]="fileMsg"
      (change)="onFileSelect($event)"
      inputId="hiddenComponentFileSelect"
    ></fileupload>
  </div>
</div>
